<div style="height: 98dvh; display: flex; justify-content: space-between; flex-direction: column">
  <div>
    <app-additional-action-header [title]="locale.currentTranslation.faqHeader"/>
    <div class="base-content-container">
      <div>
        <p class="text-body2 text-bold">{{ locale.currentTranslation.faqHeadline }}</p>
        <p class="text-body2">{{ locale.currentTranslation.faqExplanation }}</p>
      </div>
      <p class="text-body2 text-bold no-margin-bottom">{{ locale.currentTranslation.faqGeneralInformation }}</p>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <p class="no-margin">{{ locale.currentTranslation.faqGeneralInformationObligatedQuestion }}</p>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqGeneralInformationObligatedAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <p class="no-margin">{{ locale.currentTranslation.faqGeneralInformationReportQuestion }}</p>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqGeneralInformationReportAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <p class="no-margin">{{ locale.currentTranslation.faqGeneralInformationReportSpeedQuestion }}</p>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqGeneralInformationReportSpeedAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <p class="no-margin">{{ locale.currentTranslation.faqGeneralInformationReportDurationQuestion }}</p>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqGeneralInformationReportDurationAnswer1 }}</p>
          <p>{{ locale.currentTranslation.faqGeneralInformationReportDurationAnswer2 }}</p>
        </div>
      </app-expansion-panel>

      <p class="text-body2 text-bold no-margin-bottom">{{ locale.currentTranslation.faqInsuranceCoverage }}</p>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqInsuranceCoverageQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqInsuranceCoverageAnswerLiabilityInsurance }}</p>
          <p
            class="text-bold no-margin-bottom">{{ locale.currentTranslation.faqInsuranceCoverageAnswerInsuranceCovers }}</p>
          <ul class="no-margin-top">
            <li class="text-bold">{{ locale.currentTranslation.faqInsuranceCoverageAnswerBodilyInsurance }}</li>
            <div>{{ locale.currentTranslation.faqInsuranceCoverageAnswerBodilyInsuranceExample }}</div>
            <li class="text-bold">{{ locale.currentTranslation.faqInsuranceCoverageAnswerPropertyDamage }}</li>
            <div>{{ locale.currentTranslation.faqInsuranceCoverageAnswerPropertyDamageExample }}</div>
          </ul>
          <p class="text-bold">{{ locale.currentTranslation.faqInsuranceCoverageAnswerNote }}</p>
          <p>{{ locale.currentTranslation.faqInsuranceCoverageAnswerNoteThirdParty }}</p>
          <p>{{ locale.currentTranslation.faqInsuranceCoverageAnswerNoteSelf }}</p>
          <p>{{ locale.currentTranslation.faqInsuranceCoverageAnswerNoteRider }}</p>
          <p>
            {{ locale.currentTranslation.faqInsuranceCoverageAnswerDetail }}
            <a [href]="locale.currentTranslation.faqInsuranceCoverageAnswerDetailLink"
               class="text-body2" rel="noopener"
               target="_blank">{{ locale.currentTranslation.faqInsuranceCoverageAnswerDetailLinkText }}.
            </a>
          </p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHowClaimComplementQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHowClaimComplementAnswerCompletion }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHowClaimHappenNextQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHowClaimHappenNextAnswerApproveMail }}</p>
          <p
            class="text-bold no-margin-bottom">{{ locale.currentTranslation.faqHowClaimHappenNextAnswerRiderMeaning }}</p>
          <p class="no-margin-top">{{ locale.currentTranslation.faqHowClaimHappenNextAnswerRiderMeaningDetail }}</p>
          <p
            class="text-bold no-margin-bottom">{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyMeaning }}</p>
          <p class="no-margin-top">{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyCovered }}</p>
          <p>{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyAdmission }}</p>
          <p>{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyAdmissionMeaning }}</p>
          <p>{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyInformationMissing }}</p>
          <p>{{ locale.currentTranslation.faqHowClaimHappenNextAnswerThirdPartyDocuments }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHowClaimViewQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHowClaimViewAnswer }}</p>
        </div>
      </app-expansion-panel>

      <p class="text-body2 text-bold no-margin-bottom">{{ locale.currentTranslation.faqTechnicalDetail }}</p>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqTechnicalDetailCreateAccountQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqTechnicalDetailCreateAccountAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqTechnicalDetailCancelClaimQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqTechnicalDetailCancelClaimAnswerYes }}</p>
          <p class="text-bold">{{ locale.currentTranslation.faqTechnicalDetailCancelClaimAnswerNote }}</p>
          <p>{{ locale.currentTranslation.faqTechnicalDetailCancelClaimAnswerSecureDeletion }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqTechnicalDetailUploadQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqTechnicalDetailUploadAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqTechnicalDetailVerificationQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqTechnicalDetailVerificationAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqTechnicalDetailSecureDataQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqTechnicalDetailSecureDataAnswer }}
            <a class="text-body2" routerLink="/data-privacy">{{ locale.currentTranslation.faqTechnicalDetailSecureDataAnswerLinkText }}</a>
          </p>
        </div>
      </app-expansion-panel>

      <p class="text-body2 text-bold no-margin-bottom">{{ locale.currentTranslation.faqHelp }}</p>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHelpSupportQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHelpSupportAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHelpWhosFaultQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHelpWhosFaultAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHelpMistakeSubmittingQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHelpMistakeSubmittingAnswer }}</p>
        </div>
      </app-expansion-panel>
      <app-expansion-panel>
        <div class="label1 text-bold" panel-header>
          <div>{{ locale.currentTranslation.faqHelpQuestion }}</div>
        </div>
        <div class="text-body2" panel-body>
          <p>{{ locale.currentTranslation.faqHelpAnswerYes }}</p>
          <p class="text-bold">{{ locale.currentTranslation.faqHelpAnswerPolicyHolderApp }}</p>
          <p>{{ locale.currentTranslation.faqHelpAnswerPolicyHolderFastContact }}</p>
          <p>{{ locale.currentTranslation.faqHelpAnswerPolicyHolderBreadcrumb }}</p>
          <p class="text-bold">{{ locale.currentTranslation.faqHelpAnswerPolicyHolderWebsite }}</p>
          <p>{{ locale.currentTranslation.faqHelpAnswerPolicyHolderChat }}</p>
          <a [href]="locale.currentTranslation.faqHelpAnswerPolicyHolderButton1Link"
             class="secondary-button text-body2 text-bold" rel="noopener"
             style="margin-top: 2em;"
             target="_blank">{{ locale.currentTranslation.faqHelpAnswerPolicyHolderButton1LinkText }} <span><img
            height="20" ngSrc="../../../../../assets/img/external-link.svg" width="20"/></span></a>
          <a [href]="locale.currentTranslation.faqHelpAnswerPolicyHolderButton2Link"
             class="secondary-button text-body2 text-bold"
             rel="noopener" style="margin-top: 1em;"
             target="_blank">{{ locale.currentTranslation.faqHelpAnswerPolicyHolderButton2LinkText }}
            <span><img height="20" ngSrc="../../../../../assets/img/external-link.svg" width="20"/></span></a>
        </div>
      </app-expansion-panel>
    </div>
  </div>
  <div style="padding: 0 22px 14px 22px">
    <app-footer/>
  </div>
</div>
